module.exports = __webpack_public_path__ + "img/cover.96b6a3bc.webp";